export default __webpack_public_path__ + "static/media/slash.de436ef6.svg";